import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { format, isValid, parseISO } from "date-fns";

const formatDate = (dateString) => {
    if (!dateString) {
        return "--";
    }

    const parsed = parseISO(dateString);
    if (!isValid(parsed)) {
        return dateString;
    }

    return format(parsed, "dd/MM/yyyy HH:mm:ss");
};

const columns = [
    {
        field: "id",
        headerName: "Id",
        sortable: false,
        width: 90,
    },
    {
        field: "entity_type",
        headerName: "Entidad",
        sortable: false,
        width: 110,
    },
    {
        field: "entity_id",
        headerName: "Entidad Id",
        sortable: false,
        width: 110,
    },
    {
        field: "action",
        headerName: "Accion",
        sortable: false,
        flex: 0.4,
        minWidth: 130,
        renderCell: (params) => <Chip size="small" label={params.value || "--"} />,
    },
    {
        field: "source",
        headerName: "Origen",
        sortable: false,
        flex: 0.3,
        minWidth: 95,
    },
    {
        field: "customer_id",
        headerName: "Cliente",
        sortable: false,
        flex: 0.25,
        minWidth: 85,
        valueGetter: (params) => params.value || "--",
    },
    {
        field: "order_id",
        headerName: "Orden",
        sortable: false,
        flex: 0.25,
        minWidth: 85,
        valueGetter: (params) => params.value || "--",
    },
    {
        field: "user_id",
        headerName: "Usuario",
        sortable: false,
        flex: 0.25,
        minWidth: 85,
        valueGetter: (params) => params.value || "--",
    },
    {
        field: "ip_address",
        headerName: "IP",
        sortable: false,
        flex: 0.35,
        minWidth: 120,
        valueGetter: (params) => params.value || "--",
    },
    {
        field: "created_at",
        headerName: "Fecha",
        sortable: false,
        flex: 0.55,
        minWidth: 155,
        valueGetter: (params) => formatDate(params.value),
    },
    {
        field: "payload",
        headerName: "Payload",
        sortable: false,
        flex: 1.5,
        minWidth: 320,
        renderCell: (params) => (
            <Typography
                variant="caption"
                sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    lineHeight: 1.35,
                }}
            >
                {JSON.stringify(params.value || {}, null, 2)}
            </Typography>
        ),
    },
];

const OperationLogsTable = ({ title, logs = [], loading = false }) => {
    const data = {
        rows: logs,
        columns,
    };

    return (
        <Box sx={{ mb: 2.5 }}>
            {title && (
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 650 }}>
                    {title}
                </Typography>
            )}

            <DataGridPro
                {...data}
                loading={loading}
                autoHeight
                getRowHeight={() => "auto"}
                disableMultipleSelection
                disableColumnMenu
                disableColumnSelector
                disableMultipleColumnsSorting
                hideFooter
                sx={{
                    backgroundColor: "white",
                    "& .MuiDataGrid-cell": {
                        py: 0.8,
                        alignItems: "flex-start",
                    },
                }}
            />
        </Box>
    );
};

export default OperationLogsTable;
